import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

const NoGlass = ({ indicators }) => (
  <div className="glass-info">
    <Typography className="prescription-title">KHÔNG KÍNH</Typography>
    <Table sx={{ borderCollapse: 'collapse' }} aria-label="Khong Kinh">
      <TableHead>
        <TableRow>
          <TableCell className="border header eye" align="center">
            Mắt
          </TableCell>
          <TableCell className="border header thi-luc" align="center">
            Thị lực
          </TableCell>
          <TableCell className="border header thi-luc" align="center">
            Kính lỗ
          </TableCell>
          <TableCell className="border header thi-luc" align="center">
            PD(mm)
          </TableCell>
          <TableCell className="border header sbdt" align="center">
            SBDT
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell
            className="border"
            component="th"
            scope="row"
            align="center"
          >
            Phải (OD)
          </TableCell>
          <TableCell className="border" align="center">
            {indicators?.noMpVa}
          </TableCell>
          <TableCell className="border" align="center">
            {indicators?.noMpPh}
          </TableCell>
          <TableCell className="border" align="center" rowSpan={2}>
            {indicators?.noPD}
          </TableCell>
          <TableCell className="border" align="center">
            {indicators?.soiBongDongTuMP}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            className="border"
            component="th"
            scope="row"
            align="center"
          >
            Trái (OS)
          </TableCell>
          <TableCell className="border" align="center">
            {indicators?.noMtVa}
          </TableCell>
          <TableCell className="border" align="center">
            {indicators?.noMtPh}
          </TableCell>
          <TableCell className="border" align="center">
            {indicators?.soiBongDongTuMT}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </div>
);

export default NoGlass;
